import { render, staticRenderFns } from "./reviewThanksBad.vue?vue&type=template&id=7f54976b&scoped=true"
import script from "./reviewThanksBad.vue?vue&type=script&lang=js"
export * from "./reviewThanksBad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54976b",
  null
  
)

export default component.exports